import React, { Component } from 'react';
import classNames from 'classnames'
import Style from './index.less';
import './index.less';

export default class LiveStartMeetingDialog extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={'dialog-wrapper-startMeeting ' + Style['dialog-wrapper-startMeeting'] + ' bubble-startMeeting ' + Style['bubble-startMeeting'] + ' top-startMeeting ' + Style['top-startMeeting'] + ' bubble-dark-startMeeting ' + Style['bubble-dark-startMeeting']}>
                {/* <div className={'top-tip-dark-startMeeting ' + Style['top-tip-dark-startMeeting']} /> */}
                <button aria-label="Close" className={'modal-close-startMeeting ' + Style['modal-close-startMeeting']} onClick={this.props.handleCloseDialog}><span className={'modal-close-x-startMeeting ' + Style['modal-close-x-startMeeting']}></span></button>
                <div className={'modal-content-startMeeting ' + Style['modal-content-startMeeting']}>
                    <h1>开启语音通话</h1>
                    <p className={'modal-p-startMeeting ' + Style['modal-p-startMeeting'] + ' dark-text-startMeeting ' + Style['dark-text-startMeeting']}>
                        与好友语音讨论，实时高清语音
                    </p>
                    <div>
                        <button className={'sm-button-startMeeting ' + Style['sm-button-startMeeting']} type="black" onClick={this.props.handleOpenMeeting}>开启通话</button>
                    </div>
                    <p className={'bottom-tip-startMeeting ' + Style['bottom-tip-startMeeting']}>Powered by 腾讯会议
                    </p>
                </div>
            </div>
        );
    }
}